"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = dataAnalyticsMetricsSubscriber;
function dataAnalyticsMetricsSubscriber(digitalDataEvent, metricsTrackerConfig) {
  // Verify that the required values are present and we're not being
  // bypassed before continuing. If not, exit quietly.
  if (digitalDataEvent.data.disableDA === true || !digitalDataEvent.data.actionFlow || !digitalDataEvent.data.actionType) {
    return;
  }
  var eventData = JSON.parse(JSON.stringify(digitalDataEvent.data));
  var dataAnalyticsAPIPath = metricsTrackerConfig.dataAnalyticsAPIPath,
    legacyWeb = metricsTrackerConfig.legacyWeb;
  var eventMeta = {
    ui_event: '',
    ui_goal: '',
    url: '',
    origin: '',
    legacy_web: legacyWeb
  };
  eventMeta.ui_event = eventData.actionType;
  eventMeta.ui_goal = eventData.actionFlow;
  eventMeta.url = window.location.href;
  eventMeta.origin = eventData.origin || 'user';
  delete eventData.actionType;
  delete eventData.actionFlow;
  delete eventData.origin;
  // FUTURE: The listener should implement experiments metrics.

  // Send the event to the data analytics api
  if (dataAnalyticsAPIPath) {
    fetch(dataAnalyticsAPIPath, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: JSON.stringify({
        data: eventData,
        meta: eventMeta
      })
    });
  }
}
module.exports = exports.default;
//# sourceMappingURL=DataAnalyticsMetricsSubscriber.js.map